import t from "prop-types";
import commonWords from "@app/common/data/DjangoCommonPasswords";
import { Trans } from "@lingui/macro";

import { css } from "@emotion/react";
import { PASSWORD_MIN_LENGTH, PASSWORD_COMPLEXITY_REG_EXP } from "../constants";

const propTypes = {
  password: t.string,
  passwordConfirm: t.string,
};

const rootStyle = theme => css`
  > div {
    margin-top: 7px;
    color: ${theme.colors.text.disableText};

    &.-ok {
      color: ${theme.colors.text.main};

      .checkbox {
        background-color: ${theme.colors.success.main};
      }
    }
  }

  .checkbox {
    display: inline-block;
    padding: 1px 4px;
    /* border: 1px solid #bbb; */
    margin-right: 6px;
    border-radius: 20px;
    font-size: 11px;
    color: #fff;
    position: relative;
    top: -1px;
    background-color: ${theme.colors.grey.dark};
    font-weight: bold;

    &::before {
      content: "\\2713";
    }
  }
`;

const PasswordValidate = (props) => {
  const { password, passwordConfirm } = props;

  const isOKLength = password.length >= PASSWORD_MIN_LENGTH;
  const isContainsLetters = password && PASSWORD_COMPLEXITY_REG_EXP.test(password);
  const isUncommon = password && !commonWords.includes(password);
  const isEqual = passwordConfirm && password === passwordConfirm;

  return (
    <div css={rootStyle} style={{ textAlign: "right" }}>
      <div className={isOKLength ? "-ok" : undefined}><Trans id="At least {PASSWORD_MIN_LENGTH} characters long" values={{ PASSWORD_MIN_LENGTH }} /><div className="checkbox" /></div>
      <div className={isContainsLetters ? "-ok" : undefined}><Trans>Contains uppercase, lowercase and special symbols</Trans><div className="checkbox" /></div>
      <div className={isUncommon ? "-ok" : undefined}><Trans>Uncommon password</Trans><div className="checkbox" /></div>
      <div className={isEqual ? "-ok" : undefined}><Trans>Passwords must match</Trans><div className="checkbox" /></div>
    </div>
  );
};

PasswordValidate.propTypes = propTypes;

export default PasswordValidate;
